import { render } from "./PurchaseForAccountingTable.vue?vue&type=template&id=aa25a590&scoped=true"
import script from "./PurchaseForAccountingTable.vue?vue&type=script&lang=js"
export * from "./PurchaseForAccountingTable.vue?vue&type=script&lang=js"

import "./PurchaseForAccountingTable.vue?vue&type=style&index=0&id=aa25a590&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa25a590"]])

export default __exports__